export const filterDuplicateWidgets = (elements) => {
    // 用于记录已经出现过的 widget 值
    const seenWidgets = new Set();
    // 用于存储过滤后的结果
    const filteredElements = [];

    for (const element of elements) {
        const widget = element.widget;
        if (!seenWidgets.has(widget)) {
            // 如果 widget 未出现过，则添加到结果中
            filteredElements.push(element);
            // 将 widget 添加到已见集合中
            seenWidgets.add(widget);
        }
    }
    return filteredElements;
};